import React, {useEffect, useState} from 'react';
import {observer} from "mobx-react-lite";
import {useWebPSupportCheck} from "react-use-webp-support-check";
import Header from "../components/Header";
import Footer from "../components/Footer";
import device from 'current-device'
import Machines from "../components/SlotMachines/Machines";
import Seo from "../components/Seo";
import {useFetching} from "../hooks/useFetching";
import {API_SLOT_MACHINES_MAIN} from "../utils/consts";
import ApiSlotMachinesMain from "../services/SlotMachines/Main";
import {useLocation} from "react-router-dom";
import Loader from "../components/Loader";
import parse from "html-react-parser";
import TopBoxing from "../components/SlotMachines/TopBoxing";
import Loading from "../components/Loading";

import bgwebp from "../img/bg.webp";
import bgpng from "../img/bg.png";

// import mmg9 from "../img/apparats/MMG-9.png";
// import mmg7 from "../img/apparats/MMG-7.png";
// import mmg6 from "../img/apparats/MMG-6.png";
// import mmg8 from "../img/apparats/MMG-8.png";
// import mmgAR from "../img/apparats/MMG-AutomaticRoulette.png";
// import chairElite from "../img/apparats/Chair_CH_Elite.png";
// import chairBlack from "../img/apparats/Chair_CH_Black.png";

const SlotMachinesPage = () => {
    const location = useLocation()
    const supportsWebP = useWebPSupportCheck();
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState();
    // const [data, setData] = useState({name: 'Ігрові автомати', content: '<p>Ігрові автомати від Champion™ - ідеальне рішення для власників гральних закладів. Усі моделі відповідають останнім тенденціям ринку ігрової індустрії. Якісна збірка із комплектуючих преміумкласу, найновіше програмне забезпечення з актуальними іграми, звуковий супровід, сучасний дизайн, зручність і простота у використанні та безпека - все це є основою при виробництві ігрових апаратів Champion™.</p>', machines: [{id: 9, name: 'MMG - 9', prev_image: mmg9}, {id: 7, name: 'MMG - 7', prev_image: mmg7}, {id: 6, name: 'MMG - 6', prev_image: mmg6}, {id: 8, name: 'MMG - 8', prev_image: mmg8}, {id: 5, name: 'MMG - Automatic Roulette', prev_image: mmgAR}, {id: 4, name: 'Chair CH Elite', prev_image: chairElite}, {id: 3, name: 'Chair CH Black', prev_image: chairBlack},],});

    const [FunctionApiSlotMachinesMain] = useFetching(async () => {
        try {
            const response = await ApiSlotMachinesMain.getApiSlotMachinesMain(API_SLOT_MACHINES_MAIN);
            setData(response.data);
        } finally {
            setLoading(false)
        }
    });

    useEffect(() => {
        FunctionApiSlotMachinesMain();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <div className='container_fluid'>
            <Seo page='slot_machines' />
            <div className="slot_machines catalog background" style={{backgroundImage: `url(${supportsWebP ? bgwebp : bgpng})`}}>
                {data ? <>
                        <Header />
                        <div className="details_content content">
                            <div className="new_games">
                                <div className="up_catalog">
                                    {data.name ? <div className="title_block">
                                        <h1>{data.name}</h1>
                                        {device.desktop ? data.content && parse(data.content) : null}
                                    </div> : null}
                                </div>
                                <div className="row">
                                    {data.machines.length ? <TopBoxing machines={data.machines} /> : null}
                                    {!device.desktop() ? data.content && <div className="title_block hidden">
                                        {parse(data.content)}
                                    </div> : null}
                                    {!loading ? <Machines /> : <Loading />}
                                </div>
                            </div>
                        </div>
                        <Footer />
                    </> : <Loader />}
            </div>
        </div>
    );
};

export default observer(SlotMachinesPage);